export const STYLE_MAP = {
  default: {
    inputWidth: '582px',
    inputwithBackArrow: '520px',
    inputwithBackArrowLeft: '72px'
  },
  colmo: {
    inputWidth: '592px',
    inputwithBackArrow: '528px',
    inputwithBackArrowLeft: '64px'
  }
}



// WEBPACK FOOTER //
// ./packages/dof-searchbar/style.js